import { ArchetypeDefinition } from '../archetypeTypes';

import { CREATIVITY_ARCHETYPES } from './modules/creativity';
import { WISDOM_ARCHETYPES } from './modules/wisdom';
import { POWER_ARCHETYPES } from './modules/power';
import { CARE_ARCHETYPES } from './modules/care';
import { LOVE_ARCHETYPES } from './modules/love';
import { EXPLORATION_ARCHETYPES } from './modules/exploration';
import { ORDER_ARCHETYPES } from './modules/order';
import { HUMOR_ARCHETYPES } from './modules/humor';
import { BELONGING_ARCHETYPES } from './modules/belonging';
import { MAGIC_ARCHETYPES } from './modules/magic';
import { INNOCENCE_ARCHETYPES } from './modules/innocence';
import { REBELLION_ARCHETYPES } from './modules/rebellion';
import { METAPHYSICS_ARCHETYPES } from './modules/metaphysics';
import { ROLE_ARCHETYPES } from './modules/roles';
import { SHADOW_ARCHETYPES } from './modules/shadow';
import { SELF_ARCHETYPES } from './modules/self';

export const ALL_ARCHETYPES: ArchetypeDefinition[] = [
    ...CREATIVITY_ARCHETYPES,
    ...WISDOM_ARCHETYPES,
    ...POWER_ARCHETYPES,
    ...CARE_ARCHETYPES,
    ...LOVE_ARCHETYPES,
    ...EXPLORATION_ARCHETYPES,
    ...ORDER_ARCHETYPES,
    ...HUMOR_ARCHETYPES,
    ...BELONGING_ARCHETYPES,
    ...MAGIC_ARCHETYPES,
    ...INNOCENCE_ARCHETYPES,
    ...REBELLION_ARCHETYPES,
    ...METAPHYSICS_ARCHETYPES,
    ...ROLE_ARCHETYPES,
    ...SHADOW_ARCHETYPES,
    ...SELF_ARCHETYPES
];


